/// <amd-module name="typeahead/features/FlightIconEnforcer" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [{
    lobs: ["PACKAGES"],
}];

export class FlightIconEnforcer implements ISuggestionsModifier {

    private static readonly FLIGHTS_ICON = "flights";
    private static readonly ORIGIN_FIELD_TYPE = "origin";

    public modifySuggestions(suggestions: any, context: IContext, options: any): Object[] {
        if (suggestions && suggestions.length > 0 && ExecutionHelper.shouldExecute(context, configuration)
                                                                                        && this.isPackageOrigin()) {
            suggestions.forEach((sugg): void => {
                if (sugg.category !== "USERHISTORY" && sugg.type !== "LIST"
                    && !TypeaheadUtils.isChildSuggestion(sugg)) {
                    sugg.icon = FlightIconEnforcer.FLIGHTS_ICON;
                }
            });
        }
        return suggestions;
    }

    private isPackageOrigin(): boolean {
        return $("input:focus").data("gcw-storeable-name") &&
            $("input:focus").data("gcw-storeable-name").indexOf(FlightIconEnforcer.ORIGIN_FIELD_TYPE) > -1;
    }
}
